var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeeth35(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 61,
    viewBox: "0 0 49 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_2777_3291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7267 60.3139C36.5834 59.5306 44.4878 43.8647 44.4878 32.8985C44.4878 21.9324 41.326 10.9662 37.3738 9.39959C33.4216 7.83299 29.4694 10.9662 23.9363 10.9662C18.4032 10.9662 16.0318 8.61628 9.70828 11.7495C3.38474 14.0994 3.38474 32.1152 5.75607 43.0814C8.1274 53.2643 14.451 61.0972 24.7267 60.3139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7201 60.2141L24.7191 60.2142C19.6114 60.6036 15.4897 58.8526 12.3476 55.7389C9.20322 52.623 7.03649 48.1383 5.85364 43.0595C4.67 37.5853 4.07811 30.3501 4.57128 24.1923C4.81789 21.113 5.33545 18.3087 6.18273 16.1306C7.03114 13.9495 8.20225 12.4158 9.74312 11.8432L9.74331 11.8437L9.75268 11.8391C12.8977 10.2808 15.0527 10.0883 17.1093 10.2824C17.8572 10.353 18.5906 10.4745 19.3573 10.6014C19.65 10.6499 19.9476 10.6992 20.2527 10.7468C21.3543 10.9185 22.5457 11.0662 23.9363 11.0662C26.3413 11.0662 28.4506 10.4774 30.3778 9.93947C30.6809 9.85488 30.9794 9.77154 31.274 9.69194C33.4477 9.10446 35.3944 8.72256 37.337 9.49255C38.2945 9.87212 39.2188 10.8286 40.067 12.2415C40.9135 13.6518 41.6763 15.5037 42.3171 17.6528C43.5985 21.9507 44.3878 27.424 44.3878 32.8985C44.3878 38.3608 42.4181 45.0003 38.9694 50.3708C35.5199 55.7424 30.604 59.8254 24.7201 60.2141Z",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2777_3291",
    x: 0.296875,
    y: 0.960938,
    width: 48.1875,
    height: 59.4072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2777_3291"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2777_3291",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeeth35);
export default __webpack_public_path__ + "static/media/teeth35.11d7bf61a5ed44e886093b361d0db52b.svg";
export { ForwardRef as ReactComponent };